import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import "./NavigationItems.css";
import "./donates.css";

function DoantesContainer(props) {
  return (
    <div id="donates" className="page">
      <h1>Donates</h1>
      <hr />
      {props.isAuth && (
        <Button design="raised" mode="accent" onClick={props.onAddDonate}>
          New donate
        </Button>
      )}
      <ul id="donate-items">{props.children} </ul>
    </div>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default DoantesContainer;
